// extracted by mini-css-extract-plugin
export default {"component":"library-item__lNPsl","itemInfo":"library-item__eNRuV","thumb":"library-item__K4mue"};